const quotationActions = {
  FETCH_QUOTATIONS_REQUEST: 'FETCH_QUOTATIONS_REQUEST',
  FETCH_QUOTATIONS_SUCCESS: 'FETCH_QUOTATIONS_SUCCESS',
  FETCH_QUOTATIONS_ERROR: 'FETCH_QUOTATIONS_ERROR',
  FETCHING_QUOTATIONS: 'FETCHING_QUOTATIONS',

  SAVE_QUOTATION_REQUEST: 'SAVE_QUOTATION_REQUEST',
  SAVE_QUOTATION_SUCCESS: 'SAVE_QUOTATION_SUCCESS',
  SAVE_QUOTATION_ERROR: 'SAVE_QUOTATION_ERROR',
  SAVING_QUOTATION: 'SAVING_QUOTATION',

  DELETE_QUOTATION_REQUEST: 'DELETE_QUOTATION_REQUEST',
  DELETE_QUOTATION_SUCCESS: 'DELETE_QUOTATION_SUCCESS',
  DELETE_QUOTATION_ERROR: 'DELETE_QUOTATION_ERROR',

  UPDATE_QUOTATION_STATUS_REQUEST: 'UPDATE_QUOTATION_STATUS_REQUEST',
  UPDATE_QUOTATION_STATUS_SUCCESS: 'UPDATE_QUOTATION_STATUS_SUCCESS',
  UPDATE_QUOTATION_STATUS_ERROR: 'UPDATE_QUOTATION_STATUS_ERROR',

  FETCH_TEMPLATES_REQUEST: 'FETCH_TEMPLATES_REQUEST',
  FETCH_TEMPLATES_SUCCESS: 'FETCH_TEMPLATES_SUCCESS',
  FETCH_TEMPLATES_ERROR: 'FETCH_TEMPLATES_ERROR',

  SAVE_TEMPLATE_REQUEST: 'SAVE_TEMPLATE_REQUEST',
  SAVE_TEMPLATE_SUCCESS: 'SAVE_TEMPLATE_SUCCESS',
  SAVE_TEMPLATE_ERROR: 'SAVE_TEMPLATE_ERROR',
  SAVING_TEMPLATE: 'SAVING_TEMPLATE',

  DELETE_TEMPLATE_REQUEST: 'DELETE_TEMPLATE_REQUEST',
  DELETE_TEMPLATE_SUCCESS: 'DELETE_TEMPLATE_SUCCESS',
  DELETE_TEMPLATE_ERROR: 'DELETE_TEMPLATE_ERROR',

  FETCH_PUBLIC_QUOTATION_REQUEST: 'FETCH_PUBLIC_QUOTATION_REQUEST',
  FETCH_PUBLIC_QUOTATION_SUCCESS: 'FETCH_PUBLIC_QUOTATION_SUCCESS',
  FETCH_PUBLIC_QUOTATION_ERROR: 'FETCH_PUBLIC_QUOTATION_ERROR',
  FETCHING_PUBLIC_QUOTATION: 'FETCHING_PUBLIC_QUOTATION',

  SEND_WHATSAPP_REQUEST: 'SEND_WHATSAPP_REQUEST',
  SEND_WHATSAPP_SUCCESS: 'SEND_WHATSAPP_SUCCESS',
  SEND_WHATSAPP_ERROR: 'SEND_WHATSAPP_ERROR',

  FETCH_QUOTATION_TAGS_REQUEST: 'FETCH_QUOTATION_TAGS_REQUEST',
  FETCH_QUOTATION_TAGS_SUCCESS: 'FETCH_QUOTATION_TAGS_SUCCESS',
  FETCH_QUOTATION_TAGS_ERROR: 'FETCH_QUOTATION_TAGS_ERROR',

  SAVE_QUOTATION_TAG_REQUEST: 'SAVE_QUOTATION_TAG_REQUEST',
  SAVE_QUOTATION_TAG_SUCCESS: 'SAVE_QUOTATION_TAG_SUCCESS',
  SAVE_QUOTATION_TAG_ERROR: 'SAVE_QUOTATION_TAG_ERROR',
  SAVING_QUOTATION_TAG: 'SAVING_QUOTATION_TAG',

  DELETE_QUOTATION_TAG_REQUEST: 'DELETE_QUOTATION_TAG_REQUEST',
  DELETE_QUOTATION_TAG_SUCCESS: 'DELETE_QUOTATION_TAG_SUCCESS',
  DELETE_QUOTATION_TAG_ERROR: 'DELETE_QUOTATION_TAG_ERROR',

  UPDATE_QUOTATION_TAGS_REQUEST: 'UPDATE_QUOTATION_TAGS_REQUEST',
  UPDATE_QUOTATION_TAGS_SUCCESS: 'UPDATE_QUOTATION_TAGS_SUCCESS',
  UPDATE_QUOTATION_TAGS_ERROR: 'UPDATE_QUOTATION_TAGS_ERROR',

  REORDER_QUOTATIONS_REQUEST: 'REORDER_QUOTATIONS_REQUEST',
  REORDER_QUOTATIONS_SUCCESS: 'REORDER_QUOTATIONS_SUCCESS',
  REORDER_QUOTATIONS_ERROR: 'REORDER_QUOTATIONS_ERROR',

  FETCH_QUOTATION_LOGS_REQUEST: 'FETCH_QUOTATION_LOGS_REQUEST',
  FETCH_QUOTATION_LOGS_SUCCESS: 'FETCH_QUOTATION_LOGS_SUCCESS',
  FETCH_QUOTATION_LOGS_ERROR: 'FETCH_QUOTATION_LOGS_ERROR',
  FETCHING_QUOTATION_LOGS: 'FETCHING_QUOTATION_LOGS',

  SET_CURRENT_QUOTATION: 'SET_CURRENT_QUOTATION',
  CLEAR_CURRENT_QUOTATION: 'CLEAR_CURRENT_QUOTATION',

  SET_EXECUTING_QUOTATION: 'SET_EXECUTING_QUOTATION',
  CLEAR_EXECUTING_QUOTATION: 'CLEAR_EXECUTING_QUOTATION',

  EXECUTE_QUOTATION_REQUEST: 'EXECUTE_QUOTATION_REQUEST',
  EXECUTE_QUOTATION_SUCCESS: 'EXECUTE_QUOTATION_SUCCESS',
  EXECUTE_QUOTATION_ERROR: 'EXECUTE_QUOTATION_ERROR',

  QUOTATION_LISTENERS_START: 'QUOTATION_LISTENERS_START',
  QUOTATION_COMMENTS_LISTENER_SUCCESS: 'QUOTATION_COMMENTS_LISTENER_SUCCESS',
  QUOTATION_STATUS_CHANGE: 'QUOTATION_STATUS_CHANGE',
  QUOTATION_STATUS_NOTIFICATION_DISMISS: 'QUOTATION_STATUS_NOTIFICATION_DISMISS',

  USER_MENTION_RECEIVED: 'USER_MENTION_RECEIVED',
  DISMISS_USER_MENTION_REQUEST: 'DISMISS_USER_MENTION_REQUEST',

  FETCH_QUOTATION_COMMENTS_REQUEST: 'FETCH_QUOTATION_COMMENTS_REQUEST',
  FETCH_QUOTATION_COMMENTS_SUCCESS: 'FETCH_QUOTATION_COMMENTS_SUCCESS',
  FETCH_QUOTATION_COMMENTS_ERROR: 'FETCH_QUOTATION_COMMENTS_ERROR',
  FETCHING_QUOTATION_COMMENTS: 'FETCHING_QUOTATION_COMMENTS',

  MARK_QUOTATION_SEEN_BY_MENTIONED_USER: 'MARK_QUOTATION_SEEN_BY_MENTIONED_USER',

  SAVE_QUOTATION_COMMENT_REQUEST: 'SAVE_QUOTATION_COMMENT_REQUEST',
  SAVE_QUOTATION_COMMENT_SUCCESS: 'SAVE_QUOTATION_COMMENT_SUCCESS',
  SAVE_QUOTATION_COMMENT_ERROR: 'SAVE_QUOTATION_COMMENT_ERROR',
  SAVING_QUOTATION_COMMENT: 'SAVING_QUOTATION_COMMENT',

  DELETE_QUOTATION_COMMENT_REQUEST: 'DELETE_QUOTATION_COMMENT_REQUEST',
  DELETE_QUOTATION_COMMENT_SUCCESS: 'DELETE_QUOTATION_COMMENT_SUCCESS',
  DELETE_QUOTATION_COMMENT_ERROR: 'DELETE_QUOTATION_COMMENT_ERROR',

  fetchQuotations: () => ({
    type: quotationActions.FETCH_QUOTATIONS_REQUEST,
  }),
  saveQuotation: (quotation, saveAsTemplate, templateName, patientWhatsApp) => ({
    type: quotationActions.SAVE_QUOTATION_REQUEST,
    payload: {
      quotation, saveAsTemplate, templateName, patientWhatsApp,
    },
  }),
  deleteQuotation: (quotationId) => ({
    type: quotationActions.DELETE_QUOTATION_REQUEST,
    payload: quotationId,
  }),
  updateQuotationStatus: (quotationId, status) => ({
    type: quotationActions.UPDATE_QUOTATION_STATUS_REQUEST,
    payload: { quotationId, status },
  }),
  fetchTemplates: () => ({
    type: quotationActions.FETCH_TEMPLATES_REQUEST,
  }),
  saveTemplate: (template) => ({
    type: quotationActions.SAVE_TEMPLATE_REQUEST,
    payload: template,
  }),
  deleteTemplate: (templateId) => ({
    type: quotationActions.DELETE_TEMPLATE_REQUEST,
    payload: templateId,
  }),
  fetchPublicQuotation: (quotationId, doctorId, addressId) => ({
    type: quotationActions.FETCH_PUBLIC_QUOTATION_REQUEST,
    payload: { quotationId, doctorId, addressId },
  }),
  sendWhatsApp: (quotationId, phone, messageText) => ({
    type: quotationActions.SEND_WHATSAPP_REQUEST,
    payload: { quotationId, phone, messageText },
  }),
  setCurrentQuotation: (quotation) => ({
    type: quotationActions.SET_CURRENT_QUOTATION,
    payload: quotation,
  }),
  clearCurrentQuotation: () => ({
    type: quotationActions.CLEAR_CURRENT_QUOTATION,
  }),
  fetchQuotationTags: () => ({
    type: quotationActions.FETCH_QUOTATION_TAGS_REQUEST,
  }),
  saveQuotationTag: (tag) => ({
    type: quotationActions.SAVE_QUOTATION_TAG_REQUEST,
    payload: tag,
  }),
  deleteQuotationTag: (tagId) => ({
    type: quotationActions.DELETE_QUOTATION_TAG_REQUEST,
    payload: tagId,
  }),
  updateQuotationTags: (quotationId, tags) => ({
    type: quotationActions.UPDATE_QUOTATION_TAGS_REQUEST,
    payload: { quotationId, tags },
  }),
  reorderQuotations: (orderedIds) => ({
    type: quotationActions.REORDER_QUOTATIONS_REQUEST,
    payload: orderedIds,
  }),
  fetchQuotationLogs: (quotationId) => ({
    type: quotationActions.FETCH_QUOTATION_LOGS_REQUEST,
    payload: quotationId,
  }),
  setExecutingQuotation: (quotation) => ({
    type: quotationActions.SET_EXECUTING_QUOTATION,
    payload: quotation,
  }),
  clearExecutingQuotation: () => ({
    type: quotationActions.CLEAR_EXECUTING_QUOTATION,
  }),
  executeQuotation: (quotationId, appointmentId) => ({
    type: quotationActions.EXECUTE_QUOTATION_REQUEST,
    payload: { quotationId, appointmentId },
  }),
  startQuotationListeners: () => ({
    type: quotationActions.QUOTATION_LISTENERS_START,
  }),
  dismissQuotationStatusNotification: (quotationId) => ({
    type: quotationActions.QUOTATION_STATUS_NOTIFICATION_DISMISS,
    payload: quotationId,
  }),
  fetchQuotationComments: (quotationId) => ({
    type: quotationActions.FETCH_QUOTATION_COMMENTS_REQUEST,
    payload: quotationId,
  }),
  saveQuotationComment: (comment) => ({
    type: quotationActions.SAVE_QUOTATION_COMMENT_REQUEST,
    payload: comment,
  }),
  markQuotationSeenByMentionedUser: (quotationId) => ({
    type: quotationActions.MARK_QUOTATION_SEEN_BY_MENTIONED_USER,
    payload: quotationId,
  }),
  deleteQuotationComment: (commentId, quotationId) => ({
    type: quotationActions.DELETE_QUOTATION_COMMENT_REQUEST,
    payload: { commentId, quotationId },
  }),
  dismissUserMention: (mentionId) => ({
    type: quotationActions.DISMISS_USER_MENTION_REQUEST,
    payload: mentionId,
  }),
};

export default quotationActions;
